import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IParceiroRepasse,
  IPeriodo,
} from './interfaces/apiInterfaces';
import {
  IInitialState,
  ILastTwelveMonths,
  IPartnerPassedOn,
} from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  account: '',
  finishedBoletos: {
    value: 0,
    quantity: 0,
  },
  fares: 0,
  faresReceived: {
    value: 0,
    quantity: 0,
  },
  faresPassedOn: {
    value: 0,
    quantity: 0,
  },
  income: {
    value: 0,
  },
  partnerPassedOn: [],
  lastTwelveMonths: [],
};

export const getBoletoFaresFromApi = createAction(
  '@faresApp/boletoFares/GET_BOLETO_FARES_FROM_API'
);

export const gotBoletoFaresFromApi = createAction<any>(
  '@faresApp/boletoFares/GOT_BOLETO_FARES_FROM_API'
);

export const gotErrorFromBoletoFaresApi = createAction(
  '@faresApp/boletoFares/GOT_ERROR_FROM_BOLETO_FARES_API'
);

export const displayBoletoFares = createAction<boolean>(
  '@faresApp/boletoFares/DISPLAY_BOLETO_FARES'
);

export const setAccountBoletosFares = createAction<any>(
  '@faresApp/boletoFares/SET_ACCOUNT_BOLETO_FARES'
);

export const logoutBoletosFaresApp = createAction(
  '@clientsApp/LOGOUT_BOLETOS_FARES_APP'
);

function correctionForApiFailure(object: any) {
  if (object.tarifa_repassadas === undefined) {
    const mes = {
      data: object.data,
      tarifa_recebidas: {
        valor_tarifa_recebida: object.tarifa_recebidas.valor_tarifa_recebida,
        quantidade_tarifa_recebida:
          object.tarifa_recebidas.quantidade_tarifa_recebida,
      },
      tarifa_repassadas: {
        quantidade_tarifa_repassada: object.tarifas_repassadas.quantidade,
        valor_tarifa_repassada: object.tarifas_repassadas.valor,
      },
    };
    return mes;
  }
  return object;
}

const boletoFaresReducer = createReducer(INITIAL_STATE, {
  [getBoletoFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotBoletoFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    finishedBoletos: {
      value: action.payload.boleto.valor_boleto_liquidado,
      quantity: action.payload.boleto.quantidade_boleto_liquidado,
    },
    fares: action.payload.tarifa,
    faresReceived: {
      value: action.payload.tarifa_recebidas.valor_tarifa_recebida,
      quantity: action.payload.tarifa_recebidas.quantidade_tarifa_recebida,
    },
    faresPassedOn: {
      value: action.payload.tarifa_repassadas.valor_tarifa_repassada,
      quantity: action.payload.tarifa_repassadas.quantidade_tarifa_repassada,
    },
    income: {
      value: action.payload.receita.valor,
    },
    partnerPassedOn: action.payload.parceiro_repasse.map(
      (parceiro: IParceiroRepasse) => {
        const data: IPartnerPassedOn = {
          partner: parceiro.parceiro,
          amountPassedOn: parceiro.quantidade_tarifa_repassada,
          valuePassedOn: parceiro.valor_tarifa_repassada,
          valueReceived: parceiro.valor_tarifa_recebida,
          income: parceiro.receita,
        };
        return data;
      }
    ),
    lastTwelveMonths: action.payload.periodo.map((mes: IPeriodo) => {
      const novoMes = correctionForApiFailure(mes);
      const data: ILastTwelveMonths = {
        date: novoMes.data,
        faresReceived: {
          value: novoMes.tarifa_recebidas.valor_tarifa_recebida,
          quantity: novoMes.tarifa_recebidas.quantidade_tarifa_recebida,
        },
        faresPassedOn: {
          value: novoMes.tarifa_repassadas.valor_tarifa_repassada,
          quantity: novoMes.tarifa_repassadas.quantidade_tarifa_repassada,
        },
      };
      return data;
    }),
  }),
  [setAccountBoletosFares.type]: (state: IInitialState, action) => ({
    ...state,
    account: action.payload,
  }),
  [gotErrorFromBoletoFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displayBoletoFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutBoletosFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    dateSearch: {
      start: '',
      end: '',
    },
    account: '',
    finishedBoletos: {
      value: 0,
      quantity: 0,
    },
    faresReceived: {
      value: 0,
      quantity: 0,
    },
    faresPassedOn: {
      value: 0,
      quantity: 0,
    },
    income: {
      value: 0,
    },
    partnerPassedOn: [],
    lastTwelveMonths: [],
  }),
});

export default boletoFaresReducer;
